<app-login *ngIf="loaded"
  [dataGroupItemInstance]="dataGroupItemInstance"
  [widgetId]="widgetId + '_login'"
  [formClass]="dataGroupItemInstance.dataClassName">
</app-login>
